import React from "react";
import { Box, makeStyles, Typography } from "@material-ui/core";

import { COLORS } from "../../../theme/colors";
import { Icon } from "../../../components/base";

const useStyles = makeStyles(() => ({
  card: {
    width: 110,
    height: 135,
    borderRadius: 8,
    marginRight: 10,
    boxShadow: `0px 4px 10px 0px ${COLORS.darks[0][6]}`,
    background: COLORS.white,
    "&:hover": {
      background: COLORS.purples[0],
    },
    cursor: "pointer",
  },
  centerData: {
    display: "flex",
    justifyContent: "center",
    marginTop: 26,
    cursor: "pointer",
  },
  text: {
    display: "flex",
    justifyContent: "center",
  },
  label: {
    color: COLORS.davisGrey,
    fontSize: 12,
    width: 75,
    padding: 5,
    display: "flex",
    justifyContent: "center",
    textAlign: "center",
  },
  labelSelected: {
    color: "white",
  },
}));

const IconCard = ({
  id,
  src,
  text,
  onClick,
  style,
  selected,
  design,
  centerStyle,
  inElectricityData,
  width,
  height,
  Component,
}) => {
  const classes = useStyles();
  return (
    <Box
      className={`${design ? design : classes.card}`}
      style={{
        ...style,
        background: selected ? COLORS.purple : COLORS.white,
      }}
      onClick={() => onClick(id)}
    >
      {Component ? (
        <Component selected={selected} />
      ) : (
        <Box className={centerStyle ? centerStyle : classes.centerData}>
          {inElectricityData ? (
            <Icon src={src} width={35} height={35} hoverable />
          ) : (
            <Icon src={src} width={width ? width : 45} height={height ? height : 50} />
          )}
        </Box>
      )}
      {text && (
        <Box className={classes.text}>
          <Typography
            className={selected ? `${classes.label} ${classes.labelSelected}` : classes.label}
            style={{ color: selected ? COLORS.white : COLORS.davisGrey }}
          >
            {text}
          </Typography>
        </Box>
      )}
    </Box>
  );
};

export default IconCard;
